import React from "react";
import { Alert, Modal, Tag } from "antd";
import { useTranslation } from "react-i18next";

/** Before printing stellingbordjes: which stellingen, and which vakken are on no sign (and why). */
const RackSignModal = ({ open, signs, skipped, selection, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={t("pick_route.print_signs_title")}
      okText={t("pick_route.print_signs_confirm", { count: signs.length })}
      cancelText={t("cancel")}
      okButtonProps={{ disabled: signs.length === 0 }}
      onOk={onConfirm}
      onCancel={onCancel}
    >
      <p style={{ color: "#6b6b6b" }}>{t("pick_route.print_signs_help")}</p>
      {selection && <p>{t("pick_route.print_signs_selection")}</p>}
      {skipped > 0 && <Alert type="warning" showIcon className="mb-3" message={t("pick_route.print_signs_skipped", { count: skipped })} />}
      {signs.length === 0 ? (
        <Alert type="info" showIcon message={t("pick_route.print_signs_none")} />
      ) : (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {signs.map((sign) => (
            <Tag key={sign.rack} style={{ fontSize: 14, padding: "2px 8px" }}>
              {sign.rack} <span style={{ color: "#8c8c8c" }}>({sign.count})</span>
            </Tag>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default RackSignModal;
